import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bt',
  templateUrl: './bt.component.html',
  styleUrls: ['./bt.component.css']
})
export class BtComponent implements OnInit {

  public searchTableOne = '';
  public searchTableTwo = '';

  public inseticidesTable = [];

  public viewMode: string;

  constructor() { }

  private buildJsonTemplate(mode: string, array_test: any) {

    this.viewMode = mode;

    let result = [];
    const temp = ["__0", "__1", "__2", "__3", "__4", "__5", "__6", "__7", "__8", "__9", "__10"];
    const pests = ['Cotton bollworm', 'Tobacco budworm', 'Southern armyworm', 'Fall armyworm', 'Garden armyworm', 'Yellow-striped armyworm', 'Beet armyworm', 'Cotton aphid', 'Whiteflies', 'Black cutworm', 'Flower thrips', 'Two-spotted spider mites', 'Stink bug', 'Snails', 'Cabbage looper', 'Soybean looper'];

    if (mode === 'pest') {

      result = [];
      pests.forEach(pest => {
        result.push({
          info: '',
          group1: pest,
          group2: []
        });
      });

      result = result.map(pest => {
        const inseticidesList = [];
        const inseticides = array_test.map(item => {
          temp.forEach(i => {
            if (item[i].split(' (')[0] === pest.group1) {
              inseticidesList.push({
                label: item.inseticide,
                phi: item.phi,
                rei: item.rei,
                info: ' (' + item[i].match(/\(([^)]+)\)/)[1] + ' oz/A)',
                id: item.inseticide,
                collapsed: true,
                group3: [{label: (item.actionnumber + '  ' + item.chemicalgroup), info: item[i].match(/\(([^)]+)\)/)[1] }]
              });
            }
          });
        });
        pest.group2 = inseticidesList;
        return pest;
      });

    } else if (mode === 'inseticide') {

      result = [];
      const map = new Map();
      for (const item of array_test) {
        if (!map.has(item.chemicalgroup)) {
          map.set(item.chemicalgroup, true); // set any value to Map
          result.push({
            info: item.actionnumber,
            group1: item.chemicalgroup,
            group2: []
          });
        }
      }

      result = result.map(element => {
        const items = array_test.filter(x => x.chemicalgroup === element.group1);

        // trata dos inseticidas
        items.map(item => {

          const inseticides = [];
          temp.forEach(sub => {

            if (item[sub] === '') {
              return;
            }

            if (item[sub]) {
              inseticides.push({
                label: item[sub].split('(')[0], info: item[sub].match(/\(([^)]+)\)/)[1]
              });
            }
          });

          element.group2.push({
            label: item.inseticide,
            id: item.inseticide,
            phi: item.phi,
            rei: item.rei,
            info: '',
            collapsed: true,
            group3: inseticides
          });
        });
        return element;
      });
    }

    return result;

  }

  public changeInseticidesViewMode(viewMode: string): void {

    this.viewMode = viewMode;

    let insestitideTable = [
      {
        'actionnumber': 6,
        'chemicalgroup': 'Avermectins',
        'inseticide': 'Abamectin',
        'rei': '4 days',
        'phi': '20 days',
        '__0': 'Two-spotted spider mites (8)',
        '__1': 'Cotton aphid (8)',
        '__2': 'Whiteflies (8)',
        '__3': 'Seedling thrips (8)',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4 A',
        'chemicalgroup': 'Neonicotinoids',
        'inseticide': 'Admire Pro',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Cotton aphid (7.4 – 9.2)',
        '__1': 'Whiteflies (7.4 – 9.2)',
        '__2': 'Seedling thrips (7.4 – 9.2)',
        '__3': 'Stink bug (0.9 - 1.7)',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': 28,
        'chemicalgroup': 'Diamide',
        'inseticide': 'Altacor',
        'rei': '4 hours',
        'phi': '21 days',
        '__0': 'Cotton bollworm (3.0 – 4.0)',
        '__1': 'Tobacco budworm (3.0 – 4.0)',
        '__2': 'Southern armyworm (2.0 – 4.0)',
        '__3': 'Fall armyworm (2.0 – 4.0)',
        '__4': 'Garden armyworm (2.0 – 4.0)',
        '__5': 'Yellow-striped armyworm (2.0 – 4.0)',
        '__6': 'Beet armyworm (2.0 – 4.0)',
        '__7': 'Cabbage looper (3.0 – 4.5)',
        '__8': 'Soybean looper (3.0 – 4.5)',
        '__9': 'Black cutworm (2.0 – 4.0)',
        '__10': ''
      },
      // {
      //   'actionnumber': '3 A',
      //   'chemicalgroup': 'Pyrethroid',
      //   'inseticide': 'Ammo',
      //   '__0': 'Cotton bollworm (2 – 5)',
      //   '__1': 'Tobacco budworm (2 – 5)',
      //   '__2': 'Cabbage looper (2 -5)',
      //   '__3': 'Seedling thrips (2 -5)',
      //   '__4': 'Fall armyworm (2 -5)',
      //   '__5': 'Tobacco budworm (2 -5)',
      //   '__6': 'Whiteflies (2 -5)',
      //   '__7': 'Yellow-striped armyworm (1.3 – 5.0)',
      //   '__8': 'Beet armyworm (3 – 5)',
      //   '__9': 'Black cutworm (1.3 – 5.0)'
      // },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Asana XL',
        'rei': '12 hours',
        'phi': '12 days',
        '__0': 'Cotton bollworm (5.8 – 9.6)',
        '__1': 'Tobacco budworm (5.8 – 9.6)',
        '__2': 'Southern armyworm (5.8 – 9.6)',
        '__3': 'Fall armyworm (5.8 – 9.6)',
        '__4': 'Garden armyworm (5.8 – 9.6)',
        '__5': 'Yellow-striped armyworm (5.8 – 9.6)',
        '__6': 'Beet armyworm (5.8 – 9.6)',
        '__7': 'Cotton aphid (5.8 – 9.6)',
        '__8': 'Whiteflies (5.8 – 9.6)',
        '__9': 'Black cutworm (3.2 – 9.6)',
        '__10': ''
      },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Baythroid XL',
        'rei': '12 hours',
        'phi': '0 days',
        '__0': 'Cotton bollworm (1.6 – 2.6)',
        '__1': 'Black cutworm (0.8 – 1.6)',
        '__2': 'Seedling thrips (0.8 – 1.6)',
        '__3': 'Cotton aphid (1.6 – 2.6)',
        '__4': 'Cabbage looper (1.6 – 2.6)',
        '__5': 'Tobacco budworm (1.6 – 2.6)',
        '__6': 'Yellow-striped armyworm (3.2)',
        '__7': 'Beet armyworm (3 .2)',
        '__8': 'Soybean looper (3 .2)',
        '__9': 'Fall armyworm (3 .2)',
        '__10': 'Stink bug (1.6 - 2.8)'
      },
      {
        'actionnumber': '1 B',
        'chemicalgroup': 'Organophosphate',
        'inseticide': 'Bidrin',
        'rei': '3 days',
        'phi': '30 days',
        '__0': 'Seedling thrips (1.5 – 3.2)',
        '__1': 'Flower thrips (1.5 – 3.2)',
        '__2': 'Cotton aphid (4.0 – 8.0)',
        '__3': 'Two-spotted spider mites (4.0 – 8.0)',
        '__4': 'Stink bug (4 - 8)',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Brigade',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Cotton bollworm (2.6 – 6.4)',
        '__1': 'Tobacco budworm (2.6 – 6.4)',
        '__2': 'Southern armyworm (2.6 – 6.4)',
        '__3': 'Fall armyworm (2.6 – 6.4)',
        '__4': 'Garden armyworm (2.6 – 6.4)',
        '__5': 'Yellow-striped armyworm (2.6 – 6.4)',
        '__6': 'Beet armyworm (2.6 – 6.4)',
        '__7': 'Cabbage looper (2.6 – 6.4)',
        '__8': 'Soybean looper (2.6 – 6.4)',
        '__9': 'Black cutworm (2.6 – 6.4)',
        '__10': 'Stink bug (2.6 - 6.4)'
      },
      {
        'actionnumber': 29,
        'chemicalgroup': 'Flonicamid',
        'inseticide': 'Carbine',
        'rei': '12 hours',
        'phi': '30 days',
        '__0': 'Cotton aphid (1.4 – 2.8)',
        '__1': 'Whiteflies (1.4 – 2.8)',
        '__2': 'Seedling thrips (1.4 – 2.8)',
        '__3': 'Flower thrips (1.4 – 2.8)',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4 A',
        'chemicalgroup': 'Neonicotinoids',
        'inseticide': 'Centric',
        'rei': '12 hours',
        'phi': '21 days',
        '__0': 'Cotton aphid (1.2 – 2.5)',
        '__1': 'Whiteflies (2 – 2.5)',
        '__2': 'Seedling thrips (2 – 2.5)',
        '__3': 'Flower thrips (2 – 2.5)',
        '__4': 'Stink bug (2 - 2.5)',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': 16,
        'chemicalgroup': 'Buprofezin',
        'inseticide': 'Courier',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Whiteflies (9 - 12.5)',
        '__1': '',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Declare',
        'rei': '24 hours',
        'phi': '21 days',
        '__0': 'Cotton bollworm (1.2 – 2.0)',
        '__1': 'Tobacco budworm (1.2 – 2.0)',
        '__2': 'Southern armyworm (0.5 – 2.0)',
        '__3': 'Fall armyworm (1.28 - 2.05)',
        '__4': 'Garden armyworm (0.5 – 2.0)',
        '__5': 'Yellow-striped armyworm (0.5 – 2.0)',
        '__6': 'Beet armyworm (0.5 – 2.0)',
        '__7': 'Cotton aphid (0.5 – 2.0)',
        '__8': 'Black cutworm (0.77 – 1.02)',
        '__9': 'Stink bug (1.02 - 1.54)',
        '__10': ''
      },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Delta Gold',
        'rei': '12 hours',
        'phi': '21 days',
        '__0': 'Cotton bollworm (1.1 – 2.6)',
        '__1': 'Fall armyworm (1.1 – 2.6)',
        '__2': 'Southern armyworm (1.1 – 2.6)',
        '__3': 'Garden armyworm (1.1 – 2.6)',
        '__4': 'Yellow-striped armyworm (1.1 – 2.6)',
        '__5': 'Beet armyworm (1.1 – 2.6)',
        '__6': 'Soybean looper (1.1 – 2.6)',
        '__7': 'Seedling thrips (1.1 – 2.6)',
        '__8': 'Black cutworm (1.1 – 2.6)',
        '__9': 'Stink bug (1.6 - 2.6)',
        '__10': ''
      },
      {
        'actionnumber': 15,
        'chemicalgroup': 'Benzoylureas',
        'inseticide': 'Diamond',
        'rei': '12 hours',
        'phi': '30 days',
        '__0': 'Cotton bollworm (12 – 14)',
        '__1': 'Tobacco budworm (12 – 14)',
        '__2': 'Fall armyworm (6 – 12)',
        '__3': 'Beet armyworm (6 – 12)',
        '__4': 'Cabbage looper (6 – 12)',
        '__5': 'Soybean looper (6 – 12)',
        '__6': 'Whiteflies (6 – 12)',
        '__7': 'Seedling thrips (6 – 14)',
        '__8': 'Flower thrips (6 – 14)',
        '__9': 'Stink bug (9 - 12)',
        '__10': ''
      },
      {
        'actionnumber': 18,
        'chemicalgroup': 'Diacylhydrazines',
        'inseticide': 'Intrepid',
        'rei': '4 hours',
        'phi': '28 days',
        '__0': 'Beet armyworm (4 – 10)',
        '__1': 'Fall armyworm (4 – 10)',
        '__2': 'Southern armyworm (4 – 10)',
        '__3': 'Garden armyworm (4 – 10)',
        '__4': 'Yellow-striped armyworm (4 – 10)',
        '__5': 'Soybean looper (4 – 10)',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4 A',
        'chemicalgroup': 'Neonicotinoids',
        'inseticide': 'Intruder',
        'rei': '12 hours',
        'phi': '28 days',
        '__0': 'Cotton aphid (0.6 – 1.1)',
        '__1': 'Whiteflies (1.7 – 2.3)',
        '__2': 'Seedling thrips (0.8 – 1.1)',
        '__3': 'Cotton bollworm (0.8 – 1.1)',
        '__4': 'Tobacco budworm (0.8 – 1.1)',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      // {
      //   'actionnumber': '3 A',
      //   'chemicalgroup': 'Pyrethroid',
      //   'inseticide': 'Karate',
      //   '__0': 'Cotton aphid (1.6 – 2.5)',
      //   '__1': 'Black cutworm (0.9-1.2)',
      //   '__2': 'Flower thrips (0.96-1.28)',
      //   '__3': 'Two-spotted spider mites (1.6 – 2.5)',
      //   '__4': 'Cabbage looper (1.2 – 1.9)',
      //   '__5': 'Cotton bollworm (1.6 – 2.5)',
      //   '__6': 'Tobacco budworm (1.6 – 2.5)',
      //   '__7': 'Fall armyworm (1.6 – 2.5)',
      //   '__8': 'Beet armyworm (1.6 – 2.5)',
      //   '__9': ''
      // },
      {
        'actionnumber': '7 C',
        'chemicalgroup': 'Pyriproxyfen',
        'inseticide': 'Knack',
        'rei': '12 hours',
        'phi': '28 days',
        '__0': 'Cotton aphid (8 – 10)',
        '__1': 'Whiteflies (8 – 10)',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '1 A',
        'chemicalgroup': 'Carbamates',
        'inseticide': 'Lannate',
        'rei': '72 hours',
        'phi': '15 days',
        '__0': 'Cotton bollworm (7.6 – 14.4)',
        '__1': 'Tobacco budworm (7.6 – 14.4)',
        '__2': 'Fall armyworm (7.6 – 14.4)',
        '__3': 'Seedling thrips (14.4)',
        '__4': 'Flower thrips (14.4)',
        '__5': 'Cotton aphid (14.4)',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '1 B',
        'chemicalgroup': 'Organophosphates',
        'inseticide': 'Lorsban',
        'rei': '24 hours',
        'phi': '14 days',
        '__0': 'Cotton bollworm (32)',
        '__1': 'Tobacco budworm (15.3-20.4)',
        '__2': 'Fall armyworm (16-32)',
        '__3': 'Garden armyworm (16-32)',
        '__4': 'Yellow-striped armyworm (16-32)',
        '__5': 'Beet armyworm (16-32)',
        '__6': 'Southern armyworm (16-32)',
        '__7': 'Cotton aphid (16-32)',
        '__8': 'Black cutworm (32)',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Mustang Max',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Cotton bollworm (2.6 – 3.6)',
        '__1': 'Fall armyworm (2.6 – 3.6)',
        '__2': 'Black cutworm (1.2 – 1.9)',
        '__3': 'Cotton aphid (2.6 – 4.0)',
        '__4': 'Tobacco budworm (1.2 – 1.9)',
        '__5': 'Yellow-striped armyworm (1.2 – 1.9)',
        '__6': 'Beet armyworm (2.6 – 4.0)',
        '__7': 'Whiteflies (2.6 – 4.0)',
        '__8': 'Seedling thrips (1.2 – 1.9)',
        '__9': 'Stink bug (2 - 2.5)',
        '__10': ''
      },
      {
        'actionnumber': '1 B',
        'chemicalgroup': 'Organophosphates',
        'inseticide': 'Orthene',
        'rei': '12 hours',
        'phi': '7 days',
        '__0': 'Seedling thrips (8 – 16)',
        '__1': 'Black cutworm (8 – 16)',
        '__2': 'Cotton aphid (8 – 16)',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': 28,
        'chemicalgroup': 'Diamide',
        'inseticide': 'Prevathon',
        'rei': '4 hours',
        'phi': '21 days',
        '__0': 'Cotton bollworm (14 -27)',
        '__1': 'Tobacco budworm (14 -27)',
        '__2': 'Southern armyworm (14 -27)',
        '__3': 'Fall armyworm (14 -27)',
        '__4': 'Garden armyworm (14 -27)',
        '__5': 'Yellow-striped armyworm (14 -27)',
        '__6': 'Beet armyworm (14 -27)',
        '__7': 'Cabbage looper (20 -29)',
        '__8': 'Soybean looper (20 -29)',
        '__9': 'Black cutworm (14 -27)',
        '__10': ''
      },
      {
        'actionnumber': 5,
        'chemicalgroup': 'Spinosyns',
        'inseticide': 'Radiant',
        'rei': '4 hours',
        'phi': '28 days',
        '__0': 'Cotton bollworm (2.8 – 8)',
        '__1': 'Tobacco budworm (2.8 – 8)',
        '__2': 'Southern armyworm (4.2 – 8)',
        '__3': 'Fall armyworm (4.2 – 8)',
        '__4': 'Garden armyworm (4.2 – 8)',
        '__5': 'Beet armyworm (4.2 – 8)',
        '__6': 'Seedling thrips (4.2 – 8)',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '22 A',
        'chemicalgroup': 'Oxadiazines',
        'inseticide': 'Steward',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Cotton bollworm (11)',
        '__1': 'Tobacco budworm (11)',
        '__2': 'Southern armyworm (9.2 – 11.3)',
        '__3': 'Fall armyworm (9.2 – 11.3)',
        '__4': 'Garden armyworm (9.2 – 11.3)',
        '__5': 'Yellow-striped armyworm (9.2 – 11.3)',
        '__6': 'Beet armyworm (9.2 – 11.3)',
        '__7': 'Cabbage looper (6.7 – 9.2)',
        '__8': 'Soybean looper (6.7 – 9.2)',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4 C',
        'chemicalgroup': 'Sulfoximines',
        'inseticide': 'Transform',
        'rei': '24 hours',
        'phi': '14 days',
        '__0': 'Cotton aphid (2.7 – 4.1)',
        '__1': 'Seedling thrips (2.7 – 4.1)',
        '__2': 'Flower thrips (2.7 – 4.1)',
        '__3': 'Whiteflies (4.1)',
        '__4': 'Stink bug (2 - 2.5)',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4 A',
        'chemicalgroup': 'Neonicotinoids',
        'inseticide': 'Venom',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Whiteflies (1 – 3)',
        '__1': 'Cotton aphid (1 – 3)',
        '__2': 'Seedling thrips (1 – 3)',
        '__3': 'Flower thrips (1 – 3)',
        '__4': 'Stink bug (3 - 4)',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },

      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Tombstone',
        'rei': '12 hours',
        'phi': '0 days',
        '__0': 'Black cutworm (0.8 - 1.6)',
        '__1': 'Seedling thrips (0.8 – 1.6)',
        '__2': 'Cotton aphid (0.8– 1.6)',
        '__3': 'Stink bug (1.6 - 2.8)',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '3 A',
        'chemicalgroup': 'Pyrethroid',
        'inseticide': 'Fastac',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Black cutworm (1.3 - 1.9)',
        '__1': 'Seedling thrips (1.3 – 1.9)',
        '__2': 'Cotton aphid (2.6 – 3.6)',
        '__3': 'Tobacco budworm (2.6 – 3.6)',
        '__4': 'Whiteflies (2.8 – 3.8)',
        '__5': 'Fall armyworm (2.6 – 3.6)',
        '__6': 'Beet armyworm (2.8 – 3.8)',
        '__7': 'Yellow-striped armyworm (2.6 – 3.6)',
        '__8': 'Stink bug (2.8 - 3.8)',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '6',
        'chemicalgroup': 'Avermectins',
        'inseticide': 'Agri-Mek',
        'rei': '12 hours',
        'phi': '20 days',
        '__0': 'Two-spotted spider mites (1.0 – 1.25)',
        '__1': '',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '21A',
        'chemicalgroup': 'METI acaricides and insecticides',
        'inseticide': 'Portal',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Two-spotted spider mites (12 - 16)',
        '__1': 'Whiteflies (32)',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '23',
        'chemicalgroup': 'Tetronic and tetramic acid derivatives',
        'inseticide': 'Oberon',
        'rei': '12 hours',
        'phi': '30 days',
        '__0': 'Two-spotted spider mites (6 - 16)',
        '__1': 'Whiteflies (32)',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '10B',
        'chemicalgroup': 'Etoxazole',
        'inseticide': 'Zeal',
        'rei': '12 hours',
        'phi': '28 days',
        '__0': 'Two-spotted spider mites (0.66 - 1.0)',
        '__1': '',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '10A',
        'chemicalgroup': 'Hexythiazox',
        'inseticide': 'Onager',
        'rei': '12 hours',
        'phi': '35 days',
        '__0': 'Two-spotted spider mites (12 - 20)',
        '__1': '',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4A',
        'chemicalgroup': 'Neonicotinoids',
        'inseticide': 'Strafer Max',
        'rei': '12 hours',
        'phi': '28 days',
        '__0': 'Whiteflies (1.7 – 2.3)',
        '__1': 'Cotton aphid (0.6 – 1.1)',
        '__2': 'Seedling thrips (0.8 – 1.1)',
        '__3': 'Flower thrips (0.8 – 1.1)',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '12C',
        'chemicalgroup': 'Propargite',
        'inseticide': 'Comite II',
        'rei': '7 days',
        'phi': '50 days',
        '__0': 'Two-spotted spider mites (20 - 36)',
        '__1': '',
        '__2': '',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '4 A',
        'chemicalgroup': 'Neonicotinoids',
        'inseticide': 'Cruiser',
        'rei': '12 hours',
        'phi': '-',
        '__0': 'Cotton aphid (0.30 – 0.37)',
        '__1': 'Seedling thrips (0.30 – 0.37)',
        '__2': 'Flower thrips (0.30 – 0.37)',
        '__3': '',
        '__4': '',
        '__5': '',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '6',
        'chemicalgroup': 'Avermectins',
        'inseticide': 'Denim',
        'rei': '12 hours',
        'phi': '21 days',
        '__0': 'Beet armyworm (6.0 – 8.0)',
        '__1': 'Cabbage looper (8 – 12)',
        '__2': 'Cotton bollworm (8 – 12)',
        '__3': 'Fall armyworm (8 – 12)',
        '__4': 'Soybean looper (8 – 12)',
        '__5': 'Tobacco budworm (8 – 12)',
        '__6': 'Two-spotted spider mites (8 – 12)',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '3A',
        'chemicalgroup': 'Pyrethroid | 4A Neonicotinoid',
        'inseticide': 'Endigo',
        'rei': '24 hours',
        'phi': '21 days',
        '__0': 'Cabbage looper (4.5 – 5.5)',
        '__1': 'Cotton bollworm (4.5 – 5.5)',
        '__2': 'Fall armyworm (4.5 – 5.5)',
        '__3': 'Whiteflies (5.0 – 6.0)',
        '__4': 'Cotton aphid (5.0 – 6.0)',
        '__5': 'Stink bug (4.5 - 6.5)',
        '__6': '',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
      {
        'actionnumber': '3A',
        'chemicalgroup': 'Pyrethroid | 4A Neonicotinoid',
        'inseticide': 'Leverage',
        'rei': '12 hours',
        'phi': '14 days',
        '__0': 'Cabbage looper (3.0 – 5.0)',
        '__1': 'Cotton aphid (3.0 – 5.0)',
        '__2': 'Black cutworm (3.0 – 5.0)',
        '__3': 'Seedling thrips (3.0 – 5.0)',
        '__4': 'Cotton bollworm (3.8 – 5.0)',
        '__5': 'Whiteflies (3.8 – 5.0)',
        '__6': 'Stink bug (3.8 - 5.0)',
        '__7': '',
        '__8': '',
        '__9': '',
        '__10': ''
      },
    ];

    if (viewMode === 'chemicalgroup') {
      this.inseticidesTable = this.buildJsonTemplate('inseticide', insestitideTable);
    } else {
      this.inseticidesTable = this.buildJsonTemplate('pest', insestitideTable);
    }

  }

  ngOnInit() {

    this.changeInseticidesViewMode('chemicalgroup');

    // let template = {
    //   "group1": "Avermectins",
    //   "info": "6",
    //   "group2": [
    //     {
    //       "collapsed": true,
    //       "label": "Abamectin",
    //       "info": "",
    //       "id": "abamectin",
    //       "group3": [
    //         { "label": "Cotton aphid", "info": "8" }
    //       ]
    //     }
    //   ]
    // };

  }

}
